import { render } from "./WheelLegend.vue?vue&type=template&id=ba4e58e0"
import script from "./_WheelLegend.js?vue&type=script&lang=js&external"
export * from "./_WheelLegend.js?vue&type=script&lang=js&external"

import "./_WheelLegend.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__